module.exports = __webpack_public_path__ + "img/22.9f67a2cc.png";